import { DatabaseStreamState } from '@databases/rovo-bridge';
import { useEffect, useState } from 'react';

type DatabaseStreamHookState = {
  isStreaming: boolean;
};

/**
 * A hook for observing the Databases streaming status from the bridge API by subscribing to DatabaseStreamState
 * Returns the latest { isStreaming }
 */
export const useDatabaseStreamState = (): DatabaseStreamHookState => {
  const [state, setState] = useState<DatabaseStreamHookState>(() => ({
    isStreaming: DatabaseStreamState.getInstance().isStreamingActive,
  }));

  useEffect(() => {
    const unsubscribe = DatabaseStreamState.getInstance().subscribe((s) => {
      setState({ isStreaming: s.isStreaming });
    });
    return unsubscribe;
  }, []);

  return state;
};
